import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ToastNotification, ConfirmationModalState } from '../../types';

interface UIState {
  toast: ToastNotification | null;
  modal: ConfirmationModalState;
  ccFormCompleted: boolean;
}

const initialState: UIState = {
  toast: null,
  modal: {
    isOpen: false,
    headerText: '',
    body: undefined,
    confirmText: '',
    cancelText: '',
    onConfirm: undefined,
    onCancel: undefined,
    large: false,
  },
  ccFormCompleted: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    // Toast Actions
    showToast: (state, action: PayloadAction<ToastNotification>) => {
      state.toast = action.payload;
    },
    hideToast: (state) => {
      state.toast = null;
    },

    // Modal Actions
    openModal: (state, action: PayloadAction<Omit<ConfirmationModalState, 'isOpen'>>) => {
      state.modal = {
        ...action.payload,
        isOpen: true,
      };
    },
    closeModal: (state) => {
      state.modal = initialState.modal;
    },

    // CC Form Status
    setCcFormCompleted: (state, action: PayloadAction<boolean>) => {
      state.ccFormCompleted = action.payload;
    },
  },
});

export const { showToast, hideToast, openModal, closeModal, setCcFormCompleted } = uiSlice.actions;

export default uiSlice.reducer;
